import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import {
  fetchRolePlayData,
  fetchRolePlayDataClear,
  getRolePlayRecordedDetail,
  getRolePlayRecordedDetailClear,
  getSubmitRolePlayDraft,
  submitParticipateForm,
} from "../../../redux/roleplay/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import { useParams } from "react-router-dom";
import VideoPlayer from "react-video-js-player";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import Loader from "../../Loader/Loader";
import ConfirmModal from "../../modal/ConfirmModal";
import { getSubProductCategoriesDataClear } from "../../../redux/courses/actions";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";

const MyRoleplayDraftComponent = ({ role_type, submitId, setShowVideo }) => {
  let dispatch = useDispatch();
  const { roleplayId } = useParams();

  const authBroker = useSelector((state) => state.auth.authBroker);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  const rpWpData = useSelector((state) => state.rolePlay.rolePlayData);
  const rpDetailData = useSelector((state) => state.rolePlay.recordedDetail);
  const submitRoleplayDraftResponse = useSelector(
    (state) => state.rolePlay.submitRoleplayDraft
  );

  const [productData, setProductData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [submitBtnName, setSubmitBtnName] = useState("Upload for review");
  const [userDetails, setUserDetails] = useState({});
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [coachSubmit, setCoachSubmit] = useState(false);
  const [positiveValue, setPositiveValue] = useState("0.00");
  const [negativeValue, setNegativeValue] = useState("0.00");
  const [neutralValue, setNeutralValue] = useState("0.00");
  const [duration, setDuration] = useState("");
  const [analytics, setAnalytics] = useState({
    wpm: 0,
  });
  const [keywordAnalysis, setKeywordAnalysis] = useState([]);
  const [recordedURL, setRecordedURL] = useState("");
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadType, setUploadType] = useState("video");
  const [uploadResponse, setUploadResponse] = useState("");
  const [formTextArea, setFormTextArea] = useState("");
  const [apiCalled, setApiCalled] = useState(false);
  const [videoInstance, setVideoInstance] = useState(null);
  const [isEditable, setIsEditable] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [showGreenTick, setShowGreenTick] = useState(false)

  useEffect(() => {
    if (!_.isEmpty(userDetailRes?.payload?.payload)) {
      setUserDetails(userDetailRes?.payload?.payload);
    }
  }, [userDetailRes]);

  const fetchRolePlayDetail = () => {
    dispatch(
      fetchRolePlayData({
        module: "getRolePlayDetail",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: roleplayId,
        },
      })
    );
  };

  useEffect(() => {
    console.log("data--", rpWpData);
    if (!_.isEmpty(rpWpData)) {
      if (rpWpData.status === "success") {
        const payload = rpWpData.payload.payload;
        // if (type != 'review')
        dispatch(
          getRolePlayRecordedDetail({
            module: "getroleplayrecordeddetail",
            postData: {
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
              id: payload?.rp_mid,
              type: role_type,
              submit_id: submitId,
            },
          })
        );
        return () => {
          dispatch(getRolePlayRecordedDetailClear());
          dispatch(fetchRolePlayDataClear());
        };
      }
    }
  }, [rpWpData]);

  useEffect(() => {
    if (!_.isEmpty(rpDetailData)) {
      console.log("rpde---", rpDetailData);
      if (rpDetailData?.status === "success") {
        let payload = rpDetailData?.payload?.payload;
        setRecordedURL(rpDetailData?.payload?.payload?.recorded_url);
        setNegativeValue(payload?.recorded_sentiment_negative);
        setPositiveValue(payload?.recorded_sentiment_positive);
        setNeutralValue(payload?.recorded_sentiment_neutral);
        setAnalytics({ wpm: payload?.recorded_wpm });
        setFormTextArea(payload?.participator_comment);
        setProductData(rpDetailData?.payload?.payload);

        setIsLoading(false);
      }
      dispatch(fetchRolePlayDataClear());
      dispatch(getRolePlayRecordedDetailClear());
    }
  }, [rpDetailData]);

  useEffect(() => {
    setIsLoading(true);
    fetchRolePlayDetail();
  }, [roleplayId, submitId]);

  useEffect(() => {
    if (!_.isEmpty(submitRoleplayDraftResponse)) {
      if (submitRoleplayDraftResponse?.status === "success") {
        setShowVideo(true);
        setConfirmModal(true);
        setShowGreenTick(true)
        setShowModalMsg("Submitted for review successfully.");
      } else {
        setConfirmModal(true);
        setShowGreenTick(false)
        setShowModalMsg("Error! Try again later.");
      }
      setIsLoading(false);
      dispatch(getSubProductCategoriesDataClear());
    }
  }, [submitRoleplayDraftResponse]);

  const submitDraftedRoleplay = () => {
    setIsLoading(true);
    dispatch(
      getSubmitRolePlayDraft({
        module: "submitRolePlayDraft",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          id: submitId,
          comment: formTextArea,
        },
      })
    );
  };

  // Send data to backend when user selects on participating
  const setFormData = (type) => {
    let formData = new FormData();
    if (isEditable) {
      formData.append("roleplay_id", productData.roleplay_id);
      if (type === 1) {
        formData.append("action", "update");
        formData.append(
          "submit_to_coach",
          productData.submitToCoach ? productData.submitToCoach : 0
        );
        formData.append(
          "coach_id",
          productData.coach_id ? productData.coach_id : ""
        );
        if (productData.submitToCoach) {
          formData.append("submission_date", productData.submissionDate);
        }
        setIsSaveLoading(true);
      } else {
        if (!_.isEmpty(productData.feedbackData)) {
          formData.append("action", "insert");
          formData.append("submit_to_coach", 1);
          formData.append("coach_id", userDetails.coach_id);
        } else {
          formData.append("submit_to_coach", 1);
          formData.append("coach_id", userDetails.coach_id);
          formData.append("action", "update");
          setCoachSubmit(true);
        }
        setIsSubmitLoading(true);
      }
    } else {
      formData.append("action", "insert");
      if (type === 1) {
        formData.append("submit_to_coach", 0);
        formData.append("coach_id", "");
        setIsSaveLoading(true);
      } else {
        formData.append("submit_to_coach", 1);
        formData.append("coach_id", userDetails.coach_id);
        setIsSubmitLoading(true);
        setCoachSubmit(true);
      }
    }

    formData.append("uid", authBroker.payload.user.user_id);
    formData.append("brokerage_id", authBroker.payload.user.company_id);
    // formData.append('roleplay_metadata', productData.title)
    formData.append("reference_video_id", productData.role_play_id);
    // formData.append("roleplay_title", formTitle);
    formData.append("roleplay_title", productData.title);
    formData.append("situation", productData.situation);
    formData.append("description", productData.description);
    formData.append("duration", productData.duration);
    formData.append("durationUnit", productData.durationUnit);
    formData.append("thumbnail", productData.thumbnail);
    formData.append("provider_id", productData.provider_id);
    formData.append("type", productData.type);
    formData.append("url", productData.url);
    formData.append(
      "release_date",
      moment(productData.releaseDate, "DD/MM/YYYY").format("YYYY-MM-DD")
    );
    formData.append("roleplay_sentiment_negative", negativeValue);
    formData.append("roleplay_sentiment_neutral", neutralValue);
    formData.append("roleplay_sentiment_positive", positiveValue);
    formData.append("roleplay_duration", duration);
    formData.append("roleplay_wpm", analytics.wpm);
    formData.append(
      "roleplay_learningpoint",
      productData.roleplay_learningpoint
    );
    formData.append("roleplay_category", productData.roleplay_category);
    formData.append("roleplay_post_id", productData.id);
    formData.append("roleplay_sku", productData.roleplay_sku);
    formData.append(
      "roleplay_keywords",
      JSON.stringify(productData.roleplay_keywords)
    );
    formData.append(
      "roleplay_keyword_analysis",
      JSON.stringify(keywordAnalysis)
    );

    formData.append("roleplay_url", recordedURL);

    if (isUploaded) {
      formData.append("uploaded_type", uploadType);
      setIsUploaded(false);
      setUploadResponse({});
    } else {
      formData.append("uploaded_type", "video");
    }

    formData.append("additional_comment", formTextArea);

    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );

    dispatch(
      submitParticipateForm({
        module: "participateForm",
        postData: formData,
      })
    );
    setApiCalled(true);
  };

  const renderRecordPlayerArea = () => {
    console.log("recorded-url", recordedURL);
    return (
      <div>
        <VideoPlayer
          id={`roleInfo-${productData.roleplay_id}`}
          className={`img-videosec learn_image-card video-type-select `}
          controls={true}
          src={recordedURL}
          type="application/x-mpegURL"
          width="720"
          height="420"
          autoPictureInPicture={false}
          poster={""}
          fluid={true}
          inline={false}
          pictureInPictureToggle={false}
          playbackRates={[]}
          textTrackSettings={false}
          onReady={(instance) => setVideoInstance(instance)}
        />
      </div>
    );
  };

  return (
    <>
      <Loader start={isLoading} />
      <div className="row mb-2">
        <div className="col-md-12">
          <FormButtonComponent
            btnName="Back"
            leftIcon=""
            rightIcon=""
            isPrimary={false}
            replaceClassName="startcourse-btn"
            btnAction={() => setShowVideo(true)}
          />
        </div>
      </div>
      <div className="col-md-12">
        <div className="record-video">
          <div className={recordedURL ? "" : "d-none"}>
            {recordedURL ? renderRecordPlayerArea() : ""}
          </div>
        </div>
      </div>
      <div className="video-rating-role mt-2 rspratingsec">
        <div className="sentimant-box">
          <div className="d-flex ratings-role">
            <div className="rolerate">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M17.4163 25.8333C18.083 26.5 18.9441 26.8264 19.9997 26.8125C21.0552 26.7986 21.833 26.4167 22.333 25.6667L31.6663 11.6667L17.6663 21C16.9163 21.5 16.5205 22.2639 16.4788 23.2917C16.4372 24.3194 16.7497 25.1667 17.4163 25.8333ZM19.9997 6.66666C21.6386 6.66666 23.215 6.89582 24.7288 7.35416C26.2427 7.81249 27.6663 8.49999 28.9997 9.41666L25.833 11.4167C24.9163 10.9444 23.965 10.5903 22.9788 10.3542C21.9927 10.118 20.9997 9.99999 19.9997 9.99999C16.3052 9.99999 13.1594 11.2986 10.5622 13.8958C7.96495 16.493 6.66634 19.6389 6.66634 23.3333C6.66634 24.5 6.82606 25.6528 7.14551 26.7917C7.46495 27.9305 7.91634 29 8.49968 30H31.4997C32.1386 28.9444 32.6038 27.8472 32.8955 26.7083C33.1872 25.5694 33.333 24.3889 33.333 23.1667C33.333 22.1667 33.215 21.1944 32.9788 20.25C32.7427 19.3055 32.3886 18.3889 31.9163 17.5L33.9163 14.3333C34.7497 15.6389 35.4094 17.0278 35.8955 18.5C36.3816 19.9722 36.6386 21.5 36.6663 23.0833C36.6941 24.6667 36.5136 26.1805 36.1247 27.625C35.7358 29.0694 35.1663 30.4444 34.4163 31.75C34.1108 32.25 33.6941 32.6389 33.1663 32.9167C32.6386 33.1944 32.083 33.3333 31.4997 33.3333H8.49968C7.91634 33.3333 7.36079 33.1944 6.83301 32.9167C6.30523 32.6389 5.88856 32.25 5.58301 31.75C4.86079 30.5 4.30523 29.1736 3.91634 27.7708C3.52745 26.368 3.33301 24.8889 3.33301 23.3333C3.33301 21.0278 3.77051 18.868 4.64551 16.8542C5.52051 14.8403 6.71495 13.0764 8.22884 11.5625C9.74273 10.0486 11.5136 8.85416 13.5413 7.97916C15.5691 7.10416 17.7219 6.66666 19.9997 6.66666Z"
                  fill="black"
                />
              </svg>
              <div className="sentimte-rate-box">
                <strong>{analytics.wpm}</strong>
                <span className="wordtext">Words per minute</span>
              </div>
            </div>
            <div className="rolerate">
              🙂
              <div className="sentimte-rate-box">
                <strong>{positiveValue}%</strong>
                <span className="wordtext">Good</span>
              </div>
            </div>
            <div className="rolerate">
              😐
              <div className="sentimte-rate-box">
                <strong> {neutralValue}%</strong>
                <span className="wordtext">Neutral</span>
              </div>
            </div>
            <div className="rolerate">
              🙁
              <div className="sentimte-rate-box">
                <strong> {negativeValue}%</strong>
                <span className="wordtext">Poor</span>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div className="col-md-12">
        <div className="form-role-sec">
          <div className="input-text position-relative">
            <label htmlFor="date_join" className="input__label">
              Attach comment to role play
            </label>
            <textarea
              name="Addtional_Comments"
              className="input__field commentfield"
              rows="4"
              cols="50"
              placeholder={formTextArea ? formTextArea : "Enter comment..."}
              onChange={(e) => {
                setFormTextArea(e.target.value);
              }}
              value={formTextArea}
            ></textarea>
            <span className="roleplay-liner">
              The reviewer will see these comments along with the response
              itself.
            </span>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="role_frm_upload_btn edit_btn d-flex gap-4">
          <button
            className="btn-primary"
            disabled={recordedURL ? "" : true}
            onClick={() => {
              if (!isSubmitLoading) {
                setMsg("");
                if (_.toNumber(userDetails.coach_id) === 0) {
                  setMsg("You need a Coach to submit role play for review.");
                  return;
                } else {
                  submitDraftedRoleplay();
                  // setFormData(2);
                }
              }
            }}
          >
            {isSubmitLoading ? (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                variant="primary"
              />
            ) : (
              <>{submitBtnName}</>
            )}
          </button>
        </div>
        <div className="form-msg">
          <span>{msg}</span>
        </div>
      </div>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={false}
        confirmId={""}
        confirmAction={() => {}}
        isRightIcon={showGreenTick}
      />
    </>
  );
};

export default MyRoleplayDraftComponent;
